'use client';

import { ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { UserRevalidationKey, useSafeSWR } from '@headless-workspace/domain/common/client';
import {
    getRatingsAndReviewsFormServerAction,
    RatingAndReviewsFormValue,
} from '../../../../../src/server/lib/productDetail/ratingsAndReviews';

type useRatingsAndReviewsFormType = AsyncData<RatingAndReviewsFormValue>;

const RATINGS_AND_REVIEWS_FORM_DEFAULT_ERROR = 'RATINGS AND REVIEWS ERROR';

export const useRatingsAndReviewsForm = (productId: string, shouldFetch: boolean): useRatingsAndReviewsFormType => {
    const { data, isLoading, error } = useSafeSWR(
        shouldFetch ? UserRevalidationKey.RatingReviewForm : null,
        ServerActionName.getRatingAndReviewsFormServerAction,
        () => getRatingsAndReviewsFormServerAction(productId),
    );

    if (data) {
        return { isLoading, result: data };
    }

    if (error) {
        return {
            isLoading,
            result: ResultFailure(
                RATINGS_AND_REVIEWS_FORM_DEFAULT_ERROR,
                error instanceof Error ? error.message : undefined,
            ),
        };
    }

    return { isLoading, result: ResultEmpty() };
};
